const asset = (filename: string, alt: string) => ({ filename, alt, title: '', fieldtype: 'asset' })

export default {
  uuid: 'epc-homepage-preview-v1',
  name: 'EPC Homepage Preview V1',
  slug: 'homepage-preview-v1',
  full_slug: 'homepage-preview-v1',
  content: {
    _uid: 'epc-homepage-preview-v1-page',
    component: 'PageTemplate',
    sections: [
      {
        _uid: 'epc-homepage-v1-section',
        component: 'Section',
        container_width_mobile: '!max-w-full !p-0',
        container_width_tablet: 'md:!max-w-full md:!p-0',
        container_width_desktop: 'lg:!max-w-full lg:!p-0',
        blocks: [
          {
            _uid: 'epc-homepage-v1',
            component: 'EPCHomepageV1Block',
            hero_image: asset(
              'https://a.storyblok.com/f/121993/675x715/bc99dd697d/high-end-home-with-renewables.JPG',
              'A contemporary home designed with renewable energy technology',
            ),
            solar_image: asset(
              'https://a.storyblok.com/f/121993/1921x897/f13d6f2837/daniel-oc-solar-install.JPG',
              'Integrated solar panels installed on a modern home',
            ),
            battery_image: asset(
              'https://a.storyblok.com/f/121993/5000x5000/29ed9501d4/tesla-powerwall-3-battery-house.jpg',
              'Solar panels and battery storage at a modern home',
            ),
            project_image: asset(
              'https://a.storyblok.com/f/121993/1921x897/28319427a0/ground-mount-solar-system.png',
              'EPC whole-home renewable energy project',
            ),
          },
        ],
      },
    ],
  },
}
